module.exports = __webpack_public_path__ + "img/what-to-expect.6831f87b.png";